import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QMultiSelect, QSelectItem, QSelectPlaceholder, QText } from '@qualio/ui-components';
import { FilterByStatus } from '../../../displayStrings';

export const StatusFilter = ({ statusList }: { statusList: QSelectItem[] }) => {
  const { t } = useTranslation();
  return (
    <QFormControl label={t('common.labels.status')} data-cy="status-filter" w="300px">
      <Controller
        name={'status'}
        render={({ field: { onChange, value } }) => {
          return (
            <QMultiSelect
              options={statusList}
              aria-label={'status-filter'}
              onChange={(val) => onChange(val.map((c) => c.value))}
              value={value ?? []}
            >
              <QSelectPlaceholder>
                <QText>{FilterByStatus}</QText>
              </QSelectPlaceholder>
            </QMultiSelect>
          );
        }}
      />
    </QFormControl>
  );
};

export default StatusFilter;
